import { fromJS, Map } from 'immutable';
import {
  SET_HOTEL_LABELS,
  UPDATE_HOTEL_LABELS,
  SET_METAPOLICIES,
  UPDATE_METAPOLICIES,
} from '../constants/hotel';

const initialState = Map();

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_HOTEL_LABELS:
      return state.set('labels', fromJS(action.payload));

    case UPDATE_HOTEL_LABELS:
      return state.merge(fromJS({ labels: action.payload }));

    case SET_METAPOLICIES:
      return state.set('metapolicies', fromJS(action.payload));

    case UPDATE_METAPOLICIES:
      return state.merge(fromJS({ metapolicies: action.payload }));

    default:
      return state;
  }
}
